import { render, staticRenderFns } from "./tool_adapt_index.vue?vue&type=template&id=4b171683&scoped=true&"
import script from "./tool_adapt_index.vue?vue&type=script&lang=js&"
export * from "./tool_adapt_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b171683",
  null
  
)

export default component.exports